/**
 * Screensaver biome cycle — the ordered list of biomes the screensaver tours.
 *
 * Ordered for maximum visual contrast between adjacent stops (hot/cold,
 * bright/dark, open/enclosed). 12 stops × ~40s avg ≈ an 8-minute loop.
 *
 * Every `mapId` is verified present in `data/levels/*.json` (internal `id`
 * field == filename, all underscore). Cycle list lives apart from behavior
 * tunables (ScreensaverConfig.ts) per the no-monolithic-configs rule.
 */

export interface ScreensaverBiomeStop {
  /** data/levels/*.json level id (loaded via MapSystem.loadLevel). */
  readonly mapId: string;
  /** Biome key for atmosphere presets + tile textures. */
  readonly biome: string;
  /** Display name shown in the overlay. */
  readonly label: string;
  /** Seconds to linger on this biome before transitioning. */
  readonly durationS: number;
}

export const SCREENSAVER_BIOME_CYCLE: readonly ScreensaverBiomeStop[] = [
  { mapId: 'volcano_summit',      biome: 'volcanic',    label: 'Volcano Summit',      durationS: 45 },
  { mapId: 'frozen_lake',         biome: 'arctic',      label: 'Frozen Lake',         durationS: 45 },
  { mapId: 'sunken_drift',        biome: 'aquatic',     label: 'Sunken Drift',        durationS: 50 },
  { mapId: 'ancient_temple',      biome: 'celestial',   label: 'Ancient Temple',      durationS: 40 },
  { mapId: 'pig_beach',           biome: 'pig_beach',   label: 'Brinebristle Strand', durationS: 35 },
  { mapId: 'sakura_vale',         biome: 'sakura',      label: 'Sakura Vale',         durationS: 40 },
  { mapId: 'crystal_caverns',     biome: 'cave',        label: 'Crystal Caverns',     durationS: 45 },
  { mapId: 'dark_forest',         biome: 'dark_forest', label: 'Dark Forest',         durationS: 40 },
  { mapId: 'goldengrass_savanna', biome: 'savanna',     label: 'Goldengrass Savanna', durationS: 35 },
  { mapId: 'stormbreak_cliffs',   biome: 'tempest',     label: 'Stormbreak Cliffs',   durationS: 45 },
  { mapId: 'sunlit_meadow',       biome: 'meadow',      label: 'Sunlit Meadow',       durationS: 35 },
  { mapId: 'coil_undercroft',     biome: 'dark',        label: 'Coil Undercroft',     durationS: 40 },
];
